import React from "react";
import { useQuery } from "urql";
import { GET_CATEGORY_INFO } from "../../queries/getCategoryInfo.gql";
import { CategoryTree, StrapiCmsMenuItem } from "../../queries/graphql";
import { resolveImageUrlOnly } from "../../utils/resolveImageCDN";
import * as classes from "./mobileMenuLeaf.module.scss";

import { LazyLinkToCategory } from "./lazylink";
import { motion } from "framer-motion";
import { useCallback } from "react";
import placeholderImage from "../../assets/watch.png";
import { useHeaderStore } from "../../hooks/useHeaderStore";

interface IComponentProps {
  item: StrapiCmsMenuItem;
}

const MenuItem = ({ item }: IComponentProps) => {
  const categoryId = item.CategoryId;
  const setShowMenu = useHeaderStore((state) => state.setModal);
  const closeModal = useCallback(() => setShowMenu("none"), []);
  const [{ data, error }] = useQuery<{ category: CategoryTree }>({
    query: GET_CATEGORY_INFO,
    variables: {
      id: categoryId,
    },
  });
  const itemImage = item?.Image?.url;
  const categoryImage = data?.category?.thumbnail_image;

  const targetLink = data?.category?.url_path;
  return (
    <motion.a
      key={item.id}
      href={`/${targetLink}`}
      className={classes.item}
      initial={{ translateY: 10, opacity: 0 }}
      animate={{ translateY: 0, opacity: 1 }}
      onClick={closeModal}
    >
      {itemImage ? (
        <img
          className={classes.thumbnail}
          src={resolveImageUrlOnly({ src: itemImage, type: "image-cms" })}
          // loader={resolveImageCDN({ type: 'image-cms', aspectRatio: 1 })}
          alt="thumbnail"
          width={100}
          height={100}
        />
      ) : categoryImage ? (
        <img
          className={classes.thumbnail}
          src={resolveImageUrlOnly({
            src: categoryImage,
            type: "image-category",
          })}
          // loader={resolveImageCDN({ type: 'image-category', aspectRatio: 1 })}
          alt="thumbnail"
          width={100}
          height={100}
        />
      ) : (
        <img
          className={classes.thumbnail}
          src={placeholderImage.src}
          // loader={resolveImageCDN({ type: 'image-category', aspectRatio: 1 })}
          alt="thumbnail"
          width={100}
          height={100}
        />
      )}

      <div className={classes.title}>{item.Title}</div>
    </motion.a>
  );
};

const MobileMenuLeafLayoutForChildren = ({
  items,
}: {
  items: StrapiCmsMenuItem[];
}) => {
  return (
    <div className={classes.rootWithChildren}>
      {items.map((item) => {
        return <MenuItem key={item.id} item={item}></MenuItem>;
      })}
    </div>
  );
};
const MobileMenuLeafLayoutForNoChildren = ({
  parentItem,
}: {
  parentItem: StrapiCmsMenuItem;
}) => {
  const setShowMenu = useHeaderStore((state) => state.setModal);
  const closeModal = useCallback(() => setShowMenu("none"), []);
  return (
    <div className={classes.rootWithoutChildren}>
      {parentItem?.Image?.url ? (
        <img
          src={resolveImageUrlOnly({
            type: "image-cms",
            src: parentItem?.Image?.url,
          })}
          // loader={resolveImageCDN({ type: 'image-cms', aspectRatio: 1 })}
          className={classes.thumbnail}
          width={800}
          height={800}
        ></img>
      ) : (
        <img
          className={classes.thumbnail}
          src={placeholderImage.src}
          // loader={resolveImageCDN({ type: 'image-category', aspectRatio: 1 })}
          alt="thumbnail"
          width={800}
          height={800}
        />
      )}
      <div className={classes.content}>
        <div>
          <div className={classes.description}>{parentItem.Description}</div>
          <div className={classes.subtitle}>{parentItem.Subtitle}</div>
        </div>
      </div>
      <div className={classes.footer}>
        <LazyLinkToCategory
          title={parentItem.ButtonTitle}
          classes={{ root: classes.ctaButton }}
          id={parentItem.CategoryId}
        >
          <a className={classes.ctaButton} onClick={closeModal}>
            {parentItem.ButtonTitle}
          </a>
        </LazyLinkToCategory>
      </div>
    </div>
  );
};
export const MobileMenuLeaf = (props: IComponentProps) => {
  const { item } = props;
  const activeItemNonDirectChildren = item.menu_children
    .filter((el) => el.Visible)
    .filter((el) => !el.ShowUnderParent)
    .sort((a, b) => a.RelativePosition - b.RelativePosition);
  return activeItemNonDirectChildren.length > 0 ? (
    <MobileMenuLeafLayoutForChildren
      items={activeItemNonDirectChildren}
    ></MobileMenuLeafLayoutForChildren>
  ) : (
    <MobileMenuLeafLayoutForNoChildren
      parentItem={item}
    ></MobileMenuLeafLayoutForNoChildren>
  );
};
